import { render, staticRenderFns } from "./CardComp.vue?vue&type=template&id=5b7d2d0c&scoped=true&"
import script from "./CardComp.vue?vue&type=script&lang=js&"
export * from "./CardComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7d2d0c",
  null
  
)

export default component.exports